var map = {
	"./056---StartSword.json": 52713,
	"./057---AdminWeapon.json": 38204,
	"./058---QuickSword.json": 34575,
	"./059---RevengeSword.json": 30078,
	"./060---BackStabber.json": 43125,
	"./061---Bleeder.json": 90367,
	"./062---DualDaggers.json": 18123,
	"./063---BroadSword.json": 12914,
	"./064---Shovel.json": 92594,
	"./065---EvilSword.json": 64417,
	"./066---BleedCrit.json": 2142,
	"./067---SpeedBlade.json": 41048,
	"./068---GiantKiller.json": 16558,
	"./069---BulletBlade.json": 66991,
	"./070---SismicBlade.json": 80303,
	"./071---Spear.json": 61185,
	"./072---ImpaleSpear.json": 58938,
	"./073---KingsSpear.json": 23530,
	"./074---Rapier.json": 21672,
	"./075---DashSword.json": 45306,
	"./076---StunMace.json": 46471,
	"./077---BumpBoots.json": 87474,
	"./078---SpikedBoots.json": 15003,
	"./079---MultiKickBoots.json": 2228,
	"./080---QuickFists.json": 57535,
	"./081---Whip.json": 10607,
	"./082---HookWhip.json": 29930,
	"./083---OilSword.json": 52043,
	"./084---Burner.json": 36395,
	"./085---LowHealth.json": 63792,
	"./086---PerfectHalberd.json": 58786,
	"./087---BehemothHammer.json": 94700,
	"./088---TentacleWhip.json": 61925,
	"./089---Pan.json": 55562,
	"./090---ParryBlade.json": 75902,
	"./091---TickScytheLeft.json": 68509,
	"./092---TickScytheRight.json": 76155,
	"./093---RhythmicBlade.json": 34053,
	"./094---Crowbar.json": 33196,
	"./095---Katana.json": 18796,
	"./096---ExplosiveCrossBowOffHand.json": 67700
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25062;